import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { DriverData } from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

export const useGetDriverProfile = <T = DriverData>(
  select?: (data: DriverData) => T
) =>
  useQuery({
    queryFn: api.drivers.getDriverProfile,
    queryKey: queriesKeys.drivers.getDriverProfile,
    refetchOnWindowFocus: false,
    retry: false,
    select,
  })
